module.exports = __webpack_public_path__ + "static/media/UK-London.a055fb85.png";